import { BadgeCheck } from "lucide-react";

interface Props {
  size?: number;
  backgroundDataUrl?: string;
}

export const HighlightVerified = ({ size = 1080 }: Props) => {
  const iconSize = size * 0.5;
  
  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        background: "linear-gradient(135deg, #E8F5EA 0%, #D4EED8 50%, #C5E8CA 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Nunito', sans-serif",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={iconSize}
        height={iconSize}
        viewBox="0 0 24 24"
        fill="#4E8A6E"
        stroke="#4E8A6E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{
          filter: "drop-shadow(0 8px 30px rgba(78, 138, 110, 0.3))",
        }}
      >
        {/* Badge shape - green stroke */}
        <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
        {/* Checkmark - white stroke */}
        <path d="m9 12 2 2 4-4" stroke="#FFFFFF" fill="none" strokeWidth="2.5" />
      </svg>
    </div>
  );
};
